/**
 * @description Pushes event to dataLayer
 * @param { String } category - event "category"
 * @param { String } action - event "action"
 * @param { String } label - event "label"
 * @example analyticsEvent('Button', 'click', 'Play');
 */
export const analyticsEvent = (label, location, content, el) => {
    if (label && location) {
        const dataLayer = window.dataLayer || [];

        // dataLayer.push({
        //     event: "eventTracking",
        //     target: category,
        //     action,
        //     "target-properties": label,
        //     userId: "1234",
        //     userAuth: "1",
        //     screenName: "/",
        //     eventContent: null,
        //     eventContext: null,
        //     buttonLocation: null,
        //     actionGroup: "interactions",
        //     touchPoint: "web",
        // });

        const event = ['vntMenu', 'vntMain'].filter((x) => [...el.classList].includes(x))[0] || null;

        const eventCat = event === 'vntMenu' ? 'menu' : 'main';
        const eventAct = event === 'vntMenu' ? 'menu_click' : 'button_click';

        if (label === 'skachat' || label === 'skachat_s_saita' || label === 'skachat_v_google_play' || label === 'skachat_na_windows') {
            // eslint-disable-next-line no-undef
            VK.Retargeting.Init('VK-RTRG-1428086-bUkL1');
            // eslint-disable-next-line no-undef
            VK.Goal('conversion');
        }

        dataLayer.push({
            event,
            eventCategory: eventCat,
            eventAction: eventAct,
            eventLabel: label,
            eventValue: null,
            userId: null,
            userAuth: null,
            screenName: window.location.pathname.replace(/\.html/, ''),
            eventContent: content || null,
            eventContext: null,
            buttonLocation: location || null,
            actionGroup: 'interactions',
            touchPoint: 'web'
        });
    }
};
/**
 * @description Adds [data-event] event handler, which pushes event to dataLayer, according to element data-attributes.
 *
 * This function applied only to DOM-nodes which are suitable to '[data-event][data-event-category][data-event-label]' querySelector.
 */
export const registerAnalytics = () => {
    // const trackingElements = document.querySelectorAll(
    //     "[data-event][data-event-category][data-event-label]"
    // );

    const trackingElements = [
        ...document.querySelectorAll('.vntMenu'),
        ...document.querySelectorAll('.vntMain')
    ];

    if (trackingElements.length > 0) {
        trackingElements.forEach((trackingElem) => {
            trackingElem.addEventListener('click', () => {
                analyticsEvent(
                    trackingElem.getAttribute('event-label'),
                    trackingElem.getAttribute('button-location'),
                    trackingElem.getAttribute('event-content'),
                    trackingElem
                );
            });
        });
    }

    // if (trackingElements.length > 0) {
    //     trackingElements.forEach((trackingElem) =>
    //         trackingElem.addEventListener(
    //             trackingElem.getAttribute("data-event"),
    //             () => {
    //                 analyticsEvent(
    //                     trackingElem.getAttribute("data-event-category"),
    //                     trackingElem.getAttribute("data-event"),
    //                     trackingElem.getAttribute("data-event-label")
    //                 );
    //             }
    //         )
    //     );
    // }
};
